import { TNewsLetterSubscriptionFields, TNewsLetterSubscriptionProps, backgroundTheme } from '../types/newsLetterSubscription.types';
import { TImageField, TLinkField, TStringField } from '../../../types/types';

export class NewsLetterPopUpModel {
    private readonly fields?: TNewsLetterSubscriptionFields;

    constructor(props: TNewsLetterSubscriptionProps) {
        this.fields = props?.fields;
    }

    get title(): TStringField {
        return this.fields?.title as TStringField;
    }

    get image(): TImageField {
        return this.fields?.image as TImageField;
    }

    get description(): TStringField {
        return this.fields?.description as TStringField;
    }

    get link(): TLinkField {
        return this.fields?.link as TLinkField;
    }

    get isUnreleased(): boolean {
        return !!this.fields?.isComponentUnreleased;
    }

    get newsSubscriptionTitle(): TStringField {
        return this.fields?.newsSubscriptionTitle as TStringField;
    }

    get backgroundtheme(): backgroundTheme {
        return this.fields?.backgroundTheme.fields.Key.value as backgroundTheme;
    }
}
